/**
 * GROQ query that fetches all translation documents from Sanity.
 *
 * Returns an array of {@link TranslationDocument} objects sorted by key.
 */
export const TRANSLATION_QUERY = `*[_type == "translationText"] | order(key asc) {
  key,
  translation[] {
    _key,
    "translations": value[].children[] {
      _type,
      _type == "span" => {
        "value": text
      },
      _type == "variable" => {
        "variableName": name
      }
    }
  }
}`;
